import React from 'react';

// ── Tile definitions ─────────────────────────────────────────────────────────
// ids match the miscSubPage values already used in Sidebar.js / App.js routing
// (tamper, dryrun, refreshments, batteryhealth, relocation) — so selecting a
// tile just calls onSelect(id) and the existing routing in App.js takes it
// from there. No new routing concepts introduced.
const TILES = [
  { id: 'tamper',        label: 'Tamper',         desc: 'Pump & flow sensor tamper alerts',   icon: '⚠️',  color: '#FF3B30' },
  { id: 'dryrun',        label: 'Higher OutFlow', desc: 'Excess flow / dry-run detection',     icon: '🌬️', color: '#0EA5E9' },
  { id: 'refreshments',  label: 'Refreshments',   desc: 'Filter & cartridge replacement due',  icon: '♻️',  color: '#34C759' },
  { id: 'batteryhealth', label: 'Battery Health', desc: 'Battery status across devices',       icon: '🔋',  color: '#AF52DE' },
  { id: 'relocation',    label: 'Relocation',     desc: 'Device relocation requests',          icon: '🚚',  color: '#FF9F0A' },
];

const STYLES = `
  @keyframes mmFadeUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
  .mm-tile { transition: box-shadow .2s, transform .2s, border-color .2s; }
  .mm-tile:hover { box-shadow:0 10px 28px rgba(0,0,0,.1); transform:translateY(-3px); }
`;

export default function MiscellaneousMenu({ onSelect }) {
  return (
    <div style={{ fontFamily:"-apple-system,BlinkMacSystemFont,'SF Pro Display','Inter',sans-serif", maxWidth:900 }}>
      <style>{STYLES}</style>

      <div style={{ marginBottom:28 }}>
        <img src="/havells-logo.png" alt="Havells" style={{ height:48, objectFit:'contain', marginBottom:10, display:'block' }}/>
        <h1 style={{ fontSize:28, fontWeight:800, color:'#1c1c1e', letterSpacing:-.6, margin:0 }}>
          Miscellaneous
        </h1>
        <p style={{ color:'#8E8E93', fontSize:14, marginTop:4 }}>
          Choose a category to view its alerts and history
        </p>
      </div>

      <div style={{
        display:'grid',
        gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',
        gap:16,
      }}>
        {TILES.map((t, i) => (
          <button
            key={t.id}
            className="mm-tile"
            onClick={() => onSelect(t.id)}
            style={{
              textAlign:'left', cursor:'pointer', fontFamily:'inherit',
              background:'#fff', borderRadius:20, padding:'22px 20px',
              border:'1.5px solid rgba(0,0,0,.06)',
              boxShadow:'0 2px 12px rgba(0,0,0,.05)',
              animation:`mmFadeUp .3s ease ${i*.05}s both`,
              display:'flex', flexDirection:'column', gap:12,
            }}
          >
            <div style={{
              width:48, height:48, borderRadius:14,
              background:`${t.color}15`,
              display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:24,
            }}>{t.icon}</div>
            <div>
              <div style={{ fontSize:16, fontWeight:800, color:'#1c1c1e', marginBottom:4 }}>{t.label}</div>
              <div style={{ fontSize:12, color:'#8E8E93', lineHeight:1.4 }}>{t.desc}</div>
            </div>
            <div style={{ fontSize:12, fontWeight:700, color:t.color, display:'flex', alignItems:'center', gap:4, marginTop:'auto' }}>
              View <span style={{ fontSize:14 }}>→</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
